<template>
  <img
      class="mb-4"
      src="/images/logo.png"
      alt=""
      width="196"
      height="72"
  />
</template>
